import React from 'react';
import PropTypes from 'prop-types';
import { List, Button } from 'semantic-ui-react';

export const RiconciliabiliList = ({ anagrafiche, setDestination }) => (
  <List celled verticalAlign="middle" style={{ marginLeft: -20, marginRight: -20, marginBottom: -11 }}>
    { anagrafiche.map((anagrafica) => (
      <List.Item key={anagrafica.id}>
        <List.Content floated="right">
          <Button type="button" style={{ marginTop: 5 }} onClick={() => setDestination(anagrafica.id)}>È lui</Button>
        </List.Content>
        <List.Content style={{ padding: 15 }}>
          {anagrafica.nominativo}
        </List.Content>
      </List.Item>
    )
  )
}
  </List>
);

export default RiconciliabiliList;

RiconciliabiliList.propTypes = {
  anagrafiche: PropTypes.array,
  setDestination: PropTypes.func,
};




// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Base/riconciliabiliList.js